import { render, staticRenderFns } from "./TableSku.vue?vue&type=template&id=2268d95a&scoped=true"
import script from "./TableSku.vue?vue&type=script&lang=js"
export * from "./TableSku.vue?vue&type=script&lang=js"
import style0 from "./TableSku.vue?vue&type=style&index=0&id=2268d95a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2268d95a",
  null
  
)

export default component.exports